//删除url地址里的token
export function deleteUrlToken(token) {
  let replace_str = "";
  let urlhash = window.location.hash;
  let newurl = "";
  if (urlhash.indexOf("?token=") >= 0) {
    let urlsearch = window.location.href.split("?")[1];
    replace_str = "token=" + token;
    let otherparam = urlsearch.replace(replace_str, "");
    if (otherparam.length > 0) {
      replace_str += "&";
    } else {
      replace_str = "?" + replace_str;
    }
    newurl = urlhash.replace(replace_str, "");
  } else if (urlhash.indexOf("&token=") >= 0) {
    replace_str = "&token=" + token;
    newurl = urlhash.replace(replace_str, "");
  }
  if (newurl) {
    window.location.href = newurl;
  }
}

export function isMobile() {
  let ua = navigator.userAgent;
  if (
    ua.match(/Android/i) ||
    ua.match(/webOS/i) ||
    ua.match(/iPhone/i) ||
    ua.match(/iPad/i) ||
    ua.match(/iPod/i) ||
    ua.match(/BlackBerry/i) ||
    ua.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}
export function checkResponse(res) {
  if (res && res.code && res.code == 1 && res.data) {
    return true;
  } else {
    return false;
  }
}

//获取url中的参数
export function getUrlParam(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  let urlsearch = window.location.href.split("?")[1];
  if (urlsearch && urlsearch.length > 0) {
    let r = urlsearch.match(reg); //匹配目标参数
    if (r != null) return decodeURI(r[2]);
  }
  return null; //返回参数值
}
